export default "__VITE_PUBLIC_ASSET__4e46293f__"